import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import request from "../../../Helpers/API";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Swal from "sweetalert2";

export const TablaSolicitudesGeneral = ({
  data,
  filtro,
  loader,
  setLoader,
  titulo,
}) => {
  const history = useHistory();
  const [sucFlag, setSucFlag] = useState(0);
  const [detalle, setDetalle] = useState([]);
  const ShowTd = (name, idsucursal) => {
    const Linea =
      filtro.linea !== null && filtro.linea !== "" && filtro.linea !== undefined
        ? filtro.linea
        : "TT";
    var informacion = document.getElementsByClassName("row-informacion");
    var tr = document.getElementById(name);
    if (
      informacion !== undefined &&
      informacion !== null &&
      informacion.length > 0
    ) {
      for (let index = 0; index < informacion.length; index++) {
        informacion[index].className =
          "row-sucursales-detalle row-sucursales-none row-informacion";
      }
    }

    if (sucFlag === idsucursal) {
      setSucFlag(0);
      return;
    } else {
      setSucFlag(idsucursal);
    }
    if (tr !== undefined && tr !== null) {
      tr.className = "row-sucursales-detalle row-informacion";
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `SolicitudesCreditoFacturadas/SolicitudesFacturadasDetalle?ejercicio=${Number(
            titulo.ejercicio
          )}&periodo=${Number(titulo.periodo)}&idsucursal=${Number(
            idsucursal
          )}&linea=${Linea}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setDetalle(result);
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
        });
    }
  };

  const onVisualizar = (idcliente, cliente) => {
    history.push(
      "/DashClientes/Main",
      {
        idcliente: idcliente,
        cliente: cliente,
        ejercicio: titulo.ejercicio,
        periodo: titulo.periodo,
      }
    )
  }

  const onImprimirPedido = (folio, iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    // const iddocumento = 25;
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumentoPedidoFirmado?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.documento;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD DE CREDITO", error.mensaje, "error");
      });
  };
  console.log(detalle)
  return (
    <div className="solicitud-credito-facturada-container-table-scroll scroll-4">
      <table cellPadding={0} cellSpacing={0} className="table-sucursales">
        <thead className="thead">
          <tr>
            <th>Sucursal</th>
            <th>Total</th>
            {/* <th>Abiertas</th> */}
            <th>Cerradas</th>
            <th>JDF</th>
            <th>Prestamos</th>
            <th>Mhusa</th>
            <th>Contado</th>
          </tr>
        </thead>
        <tbody className="tbody">
          {data.map((item, index) => (
            <>
              <tr
                className={`tow-sucursales ${index % 2 === 0 ? "" : "tow-sucursales-2n"
                  }`}
                onClick={() => ShowTd(item.sucursal, item.idsucursal)}
              >
                <td>
                  <div>
                    <ArrowRightIcon />
                    {item.sucursal}
                  </div>
                </td>
                <td>{item.total_solicitudes}</td>
                {/* <td>{item.pendientes === 0 ? "" : item.pendientes}</td> */}
                <td>{item.cerradas === 0 ? "-" : item.cerradas}</td>
                <td>{item.jdf === 0 ? "-" : item.jdf}</td>
                <td>
                  {item.prestamos_clientes === 0
                    ? "-"
                    : item.prestamos_clientes}
                </td>
                <td>{item.mhusa === 0 ? "-" : item.mhusa}</td>
                <td>{item.contado === 0 ? "-" : item.contado}</td>
              </tr>
              <tr
                className="row-sucursales-detalle row-sucursales-none row-informacion"
                id={item.sucursal}
              >
                <td colSpan={7} className="td-sucursales-detalle">
                  <div className="row-sucursales-table">
                    <table cellPadding={0} cellSpacing={0}>
                      <thead>
                        <tr>
                          <th>Estado</th>
                          <th>Cliente</th>
                          <th>Asesor</th>
                          <th>Linea</th>
                          <th>Modelo</th>
                          <th>Operación</th>
                          <th>Creado</th>
                          <th>Facturado</th>
                          <th>Importe</th>
                          <th colSpan={2}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {detalle
                          .filter(
                            (x) => x.credito === true || x.cerrado === true
                          )
                          .map((det) => (
                            <tr
                            // onClick={() =>
                            //   history.push(
                            //     "/DashClientes/Main",
                            //     {
                            //       idcliente: det.idcliente,
                            //       cliente: det.cliente,
                            //       ejercicio: titulo.ejercicio,
                            //       periodo: titulo.periodo,
                            //     }
                            //   )
                            // }
                            >
                              <td>
                                <div className="row-sucursales-table-container">
                                  <div
                                    className={
                                      det.estatus === 1
                                        ? "row-sucursales-table-abiertas"
                                        : det.credito === true
                                          ? "row-sucursales-table-contado"
                                          : det.cerrado === true
                                            ? "row-sucursales-table-cerradas"
                                            : "row-sucursales-table-abiertas"
                                    }
                                  ></div>
                                  <div className="row-sucursales-table-container-text">
                                    {det.estatus === 1
                                      ? "Prestamo"
                                      : det.credito === true
                                        ? "Contado"
                                        : det.cerrado === true
                                          ? "Cerrada"
                                          : "Abierta"}
                                  </div>
                                </div>
                              </td>
                              <td>{det.cliente}</td>
                              <td>{det.asesor}</td>
                              <td>{det.linea}</td>
                              <td>{det.modelo}</td>
                              <td>{det.linea_credito}</td>
                              <td>{det.creado}</td>
                              <td>{det.facturado}</td>
                              <td>{FormatMoney(det.importe, 0)}</td>
                              <td>
                                <div
                                  className="boton-pedido"
                                  onClick={() => onImprimirPedido(det.folio, det.linea_credito === "JDF" ? 55 : 25)}
                                >
                                  <CloudDownloadIcon />Pedido
                                </div>
                              </td>
                              <td>
                                <div
                                  className="boton-visualizar"
                                  onClick={() => onVisualizar(det.idcliente, det.cliente)}
                                >
                                  <VisibilityIcon />Visualizar
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </>
          ))}
          <tr className="row-totales-operaciones">
            <td>TOTAL</td>
            <td>
              {data.reduce(
                (acumulador, item) => acumulador + item.total_solicitudes,
                0
              )}
            </td>
            <td>
              {data.reduce((acumulador, item) => acumulador + item.cerradas, 0)}
            </td>
            <td>
              {data.reduce((acumulador, item) => acumulador + item.jdf, 0)}
            </td>
            <td>
              {data.reduce(
                (acumulador, item) => acumulador + item.prestamos_clientes,
                0
              )}
            </td>
            <td>
              {data.reduce((acumulador, item) => acumulador + item.mhusa, 0)}
            </td>
            <td>
              {data.reduce((acumulador, item) => acumulador + item.contado, 0)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
